<template>
    <c-text-field v-if="readonly" :readonly="true" :value="readValue" :background-color="backgroundColorAdjusted" :label="label"></c-text-field>
    <v-select v-else :value="value" @change="onInput" outlined dense hide-details="auto" :items="items" :background-color="backgroundColorAdjusted" :label="label" :clearable="clearable" :disabled="disabled"></v-select>
</template>

<script>
export default {
    props: {
        value: [String, Number],
        readonly: Boolean,
        items: Array,
        label: String,
        backgroundColor: String,
        clearable: Boolean,
        disabled: Boolean
    },

    methods: {
        onInput (event) {
            // console.log(event);
            this.$emit('input', event)
        }
    },
    computed: {
        readValue () {
            if (this.items && this.items.length > 0 && this.items.filter(i => !!i.value).length > 0) {
                var selectedItem = this.items.find(i => i.value === this.value);
                return selectedItem ? selectedItem.text : null;
            }
            else {
                return this.value;
            }
        },
        backgroundColorAdjusted () {
            if (this.backgroundColor){
                return this.backgroundColor;
            }
            else if (this.readonly){
                return 'grey lighten-4';
            }
            else {
                return null;
            }
            // return this.backgroundColor ?? this.readonly ? 'grey lighten-4' : null;
        }
    }
}
</script>